import { FC, useMemo, useRef } from 'react';
import { ItemStatus } from '@/redux/back-dashboard-api';
import { OrderItemStatusBadge } from '@/components/badges/order-item-status';
import {
  DropdownButton,
  PillDropdownButton,
} from '@/components/buttons/dropdown-button';
import ChevronDownSmall from '@ingka/ssr-icon/paths/chevron-down-small';
import { getNextItemStatuses } from '@/lib/utils/items-status-machine';

export const ItemStatusDropdown: FC<{
  selected: ItemStatus;
  options?: ItemStatus[];
  onChange: (status: ItemStatus) => void;
}> = ({ selected, options, onChange }) => {
  const initialRef = useRef(selected);
  const availableOptions = useMemo(
    () => options || getNextItemStatuses(initialRef.current),
    [initialRef, options]
  );

  return (
    <DropdownButton
      size="small"
      type="tertiary"
      position="bottom-right"
      pill={{
        iconPosition: 'trailing',
        label: <OrderItemStatusBadge status={selected} />,
        size: 'small',
        ssrIcon: ChevronDownSmall,
      }}
      listBox={{
        className: '!max-w-[250px]',
      }}
    >
      {availableOptions.map((status) => (
        <PillDropdownButton
          key={status}
          text={<OrderItemStatusBadge status={status} />}
          onClick={() => onChange(status)}
        />
      ))}
    </DropdownButton>
  );
};
